<template>

  <ContentTemplate title="Figma" icon="integrations/figma.svg" :step="step + '/3'"
                   :container-size-small="true">
    <div class="jira-cloud-step">

    </div>
  </ContentTemplate>

</template>
<script lang="ts">
import {defineComponent} from 'vue';
import {ProjectNs} from '@shared/types';
import {ContentTemplate} from "@shared/components";

export default defineComponent({
  name: 'FigmaView',
  components: {
    ContentTemplate,
  },
  data() {
    return {
      allWorkspaceProjects: [] as ProjectNs.Project[],
      step: 1,
    };
  },
  // beforeMount() {
  //   store.dispatch('actionGetAllProjectsInWorkspace',
  //     { workspaceId: this.gotSelectedWorkspaceId })
  //     .then((data) => {
  //       this.allWorkspaceProjects = data;
  //     });
  // },
  // methods: {
  //   finishIntegration() {
  //     this.$router.push({ name: SettingNs.SettingRouteEnums.INTEGRATIONS });
  //   },
  // }
});
</script>

<style lang="scss">

</style>
